/**
 * Enumeration for the OptiDrive component KPIs.
 *
 * @readonly
 * @enum {string}
 */
export const OptiDriveComponentKpis = {
    SPEEDING: 'optidrive_indicator_speeding',
    DRIVING: 'optidrive_indicator_driving',
    IDLING: 'optidrive_indicator_idling',
    FUEL: 'optidrive_indicator_fuel',
    GREEN_SPEED: 'optidrive_indicator_greenspeed',
    CONSTANT_SPEED: 'optidrive_indicator_constantspeed',
    COASTING: 'optidrive_indicator_coasting',
    HIGH_REVVING: 'optidrive_indicator_highrevving',
    CRUISE_CONTROL: 'optidrive_indicator_cruisecontrol',
    ENERGY_CONSUMPTION: 'optidrive_indicator_energy_consumption',
    VIDEO: 'optidrive_indicator_video'
}

Object.freeze(OptiDriveComponentKpis)
